<template>
	<div>
		<page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

  	<v-container fluid grid-list-xl py-0>
 
			<v-layout row wrap>
				<app-card
					:fullBlock="true"
					colClasses="xl6 lg6 md6 sm12 xs12 xs12 xs12"
				>
					<v-card-title>Diensten
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							label="Search"
							single-line
							hide-details
							v-model="search"
						>
						</v-text-field>
					</v-card-title>
					<v-data-table
						v-bind:headers="headers"
						v-bind:items="items"
							:rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination"
					>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.Title }} </td>
							<td>{{ props.item.IntDuration }}</td>
							<td>{{ props.item.IntWait }}</td>
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>

					<v-dialog v-model="dialog2" max-width="500">
						<v-card>
							<v-card-title class="headline">Behandeling verwijderen?</v-card-title>
							<v-card-text>Ben je zeker dat je <strong> {{this.currentRec.Title}} </strong> wenst te verwijderen ?</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="warning" flat="flat" @click.native="dialog2 = false">Nee</v-btn>
								<v-btn color="error" flat="flat" @click.native="delRec(currentRec)">Ja</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

			</v-layout>
  	</v-container>
	</div>
</template>

<script>
import myHttpApi from "../../api/myHttpApi";
import router from '../../router';
import Vue from 'vue';

export default {
  data() {
    return {
			dialog2: false,
			currentRec : '',
			loader: true,
      max25chars: v => v.length <= 25 || "Input too long!",
      tmp: "",
      search: "",
      pagination: {},
      headers: [
        { text: "Naam", value: "Title" },
	    	{ text: "Duurtijd (min.)", value: "IntDuration" },
				{ text: "Pauzetijd (min.)", value: "IntWait" }
      ],
			items: [],
			categories: [],
			rowsPerPageItems: [10, 20, 30, 40,100],
      pagination: {
            rowsPerPage: 20
        }
    };
  },
  mounted() {
		this.search = Vue.$lastSearchServices;
		this.getTablesData();
  },
  methods: {
    getTablesData() {
      myHttpApi
		const searchRec = {Search: this.search, Extra: ""}
		myHttpApi.post( 'BOProduct/SearchService', searchRec)
        .then(response => {
					this.loader = false;
					this.items = [];
					this.items = response.data.Result;
					Vue.$lastSearchServices = this.search;
        })
        .catch(error => {
          console.log(error);
        });
		}
  },
  watch: {
        search(after, before) {
            this.getTablesData();
        }
    },

};
</script>
